const modalSize = {
    small: 'sm',
    medium: 'md',
    large: 'lg'
};

export default modalSize;
